import type { JSX } from "react";
import { Outlet } from "react-router";

import { RequireRole } from "@/components/require-role";
import { Role } from "@/lib/supabase";

// Re-export for feedback detail invalidation (key lives next to the sidebar panel).
export { FEEDBACK_STATS_QUERY_KEY } from "@/components/sidebar/settings-nav-panel";

const ADMIN_ONLY = [Role.Admin] as const;

export default function SettingsLayout(): JSX.Element {
  return (
    <div className="flex w-full min-w-0 flex-col">
      <div className="w-full min-w-0 pb-8 pl-11 pr-4 pt-8 sm:pr-6 lg:px-8 lg:pl-12 lg:pt-6">
        <Outlet />
      </div>
    </div>
  );
}

export function AdminSettingsLayout(): JSX.Element {
  return (
    <RequireRole roles={ADMIN_ONLY}>
      <Outlet />
    </RequireRole>
  );
}
